import { fieldLogFootageStatusFilterSchema } from '@/features/field-log/lib/footageReview';
import { isOperatorPresence } from '@/features/field-log/lib/sessionFilters';
import type { FieldLogVisitsFilters } from '@/features/field-log/types/fieldLog';
import type {
  FieldLogHistoryEmptyState,
  FieldLogTodaySearch,
} from '@/features/field-log/types/fieldLogList';
import { localDateRangeToUtcTimestampRange } from '@/shared/lib/dateTime';
import { z } from 'zod';

/** Keeps externally edited Today URLs from reaching the API as invalid requests. */
export const fieldLogTodaySearchSchema = z
  .object({
    hasSessions: z.boolean().optional().catch(undefined),
    footageStatus: fieldLogFootageStatusFilterSchema,
    operatorPresence: z.string().optional().catch(undefined),
    recording: z.boolean().optional().catch(undefined),
    organizationId: z.array(z.string()).optional().catch(undefined),
  })
  .transform(
    (search): FieldLogTodaySearch => ({
      hasSessions: search.hasSessions,
      footageStatus: search.footageStatus,
      operatorPresence:
        search.operatorPresence && isOperatorPresence(search.operatorPresence)
          ? search.operatorPresence
          : undefined,
      recording: search.recording,
      organizationId: search.organizationId,
    }),
  );

/** Creates the server-side interval for the current local calendar day. */
export function fieldLogTodayFilters(
  createBy: string,
  search: FieldLogTodaySearch = {},
  now = new Date(),
): FieldLogVisitsFilters {
  const { from, to } = localDateRangeToUtcTimestampRange({ from: now });
  return { createBy, startedAtFrom: from, startedAtTo: to, ...search };
}

/** Today uses the same empty-state distinction as History. */
export function fieldLogTodayEmptyState(search: FieldLogTodaySearch): FieldLogHistoryEmptyState {
  return search.hasSessions === undefined &&
    search.operatorPresence === undefined &&
    search.recording === undefined &&
    search.organizationId === undefined &&
    !search.footageStatus?.length
    ? 'unfiltered'
    : 'filtered';
}
